module.exports = __webpack_public_path__ + "images/application/i-error-help-2adf3e57.svg";